import React from 'react';

const Background = ({ children, showClouds }) => {

    const getChildren = (children) => {
        return children;
    }

    const clouds = () => {
        return <>
            <img className='background-top' src='/images/clouds_top.png' alt='' />
            <img className='background-bottom' src='/images/clouds_bottom.png' alt='' />
            <img className='background-bottom-start' src='/images/clouds_bottom_start.png' alt='' />
        </>
    }

    return <div className={showClouds?'background clouds':'background'}>
        {showClouds?clouds():null}
        <div className='right-main-content'>
            {getChildren(children)}
        </div>
     </div>;
};


export default Background;